import React, {MutableRefObject, ReactNode} from "react";
import '../../styles/components/lesson/control-bar-dropdown.scss';

interface IControlBarDropDownMenuItemProps {
  children: ReactNode;
  onClick?: () => void;
  isSelected?: boolean;
  additionalClassName?: string;
  inert?: undefined | "inert";
  refProp?: MutableRefObject<HTMLDivElement | null>;
}

export default function ControlBarDropDownMenuItem({children, isSelected, onClick, additionalClassName=``, inert, refProp}: IControlBarDropDownMenuItemProps) {
  const selectedClassName = isSelected ? "selected" : "";
  return (
    <div className={`control-bar-dropdown-menu-item ${additionalClassName} ${selectedClassName}`} onClick={onClick} inert={inert} ref={refProp}>
      {children}
    </div>
  );
}
